import { Button, ButtonProps } from "react-bootstrap";
import { Spinner } from "react-bootstrap";

import ErrorMessageComponent from "../ErrorMessage/ErrorMessage";
import "./custom-button.scss";

interface FormSubmitButtonProps extends ButtonProps {
  label: string;
  isSubmitting: boolean;
  customStyles?: React.CSSProperties;
  variant?: string;
  error?: string;
  className?: string;
  customClass?: string;
  loaderSize?: "sm" | undefined;
}

const CustomButton: React.FC<FormSubmitButtonProps> = ({
  label,
  type = "button",
  isSubmitting,
  customStyles,
  variant = "primary",
  error,
  loaderSize,
  disabled,
  customClass,
  ...rest
}) => {
  const largeScreen = window.innerWidth > 992;
  return (
    <>
      <Button
        type={type}
        variant={variant}
        className={`custom-button ${customClass ?? ""}`}
        disabled={disabled}
        style={{
          backgroundColor: disabled ? "#E6E1DA" : "#000",
          border: disabled ? "1px solid #E6E1DA" : "1px solid #000",
          ...customStyles,
        }}
        {...rest}
      >
        {!isSubmitting ? (
          label
        ) : (
          <Spinner
            size={loaderSize ? loaderSize : !largeScreen ? "sm" : undefined}
          />
        )}
      </Button>

      {error && <ErrorMessageComponent touched={true} error={error} />}
    </>
  );
};

export default CustomButton;
